import { motion } from "framer-motion";
import scrollArrow from "@/assets/brand/scroll-arrow-new.svg";

const insights = [
  {
    lead: "Creciste. Evolucionaste. Sumaste experiencia, capacidades, equipo, clientes y resultados.",
    follow: "Pero algo quedó atrás. La forma en que el mercado te percibe ya no representa la empresa en la que te convertiste. Y cuando el valor no se percibe, cuesta diferenciarlo, defenderlo y capitalizarlo."
  },
  {
    lead: "Sabés el valor que tiene tu empresa.",
    follow: "El problema es cuando el mercado todavía no lo ve. Construiste mucho para llegar hasta acá. Ahora necesitás que tu posicionamiento, tu marca y la percepción que generás estén a la altura de ese valor."
  }
];

const MethodIntro = () => {
  const scrollToMethod = () => {
    const methodSection = document.getElementById("desafio");
    if (methodSection) {
      methodSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="py-24 md:py-32 relative overflow-hidden" style={{ backgroundColor: "#0a1628" }}>
      {/* Dark blue overlay */}
      <div className="absolute inset-0 bg-[#0a1628]/70" />
      
      {/* Subtle radial glow */}
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[600px] rounded-full opacity-30 pointer-events-none"
        style={{ background: "radial-gradient(ellipse at center, rgba(59, 130, 246, 0.15) 0%, transparent 70%)" }}
      />
      
      <div className="container px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto"
        >
          {/* Main statement */}
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.15] mb-16 text-white">
            Construiste una empresa que hoy vale más de lo que logra hacer perceptible.
          </h2>

          {/* Impact quote */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mb-16"
          >
            <p className="font-display text-2xl md:text-3xl lg:text-4xl font-medium text-white leading-tight max-w-3xl mx-auto">
              El desafío no es parecer más. Es lograr que se perciba lo que realmente sos.
            </p>
            <div className="w-24 h-px mx-auto mt-8 bg-gradient-to-r from-transparent via-gold-light/60 to-transparent" />
          </motion.div>

          {/* Insight cards */}
          <div className="space-y-6 mb-16 text-left">
            {insights.map((insight, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.15 }}
                className="bg-blue-950/60 border border-blue-400/30 rounded-2xl p-8 md:p-10 backdrop-blur-sm"
              >
                <p className="font-display text-xl md:text-2xl text-white font-semibold leading-relaxed mb-4">
                  {insight.lead}
                </p>
                <p className="text-base md:text-lg text-white/90 leading-relaxed">
                  {insight.follow}
                </p>
              </motion.div>
            ))}
          </div>

          {/* Closing statement */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.6 }}
            className="mb-12 pb-20 md:pb-28"
          >
            <p className="font-display text-xl md:text-2xl lg:text-3xl font-medium text-white max-w-3xl mx-auto leading-tight">
              No querés parecer más grande. Querés ser percibido por lo que realmente construiste.
            </p>
          </motion.div>
          
          {/* Arrow down */}
          <div className="flex justify-center">
            <motion.button
              onClick={scrollToMethod}
              initial={{ opacity: 0, y: -10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="group"
            >
            <motion.img
              src={scrollArrow}
              alt="Scroll"
              className="w-10 h-auto opacity-60 hover:opacity-100 transition-opacity mx-auto"
              animate={{ y: [0, 6, 0] }}
              transition={{
                duration: 1.8,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MethodIntro;
